import React from 'react';
import Text from 'components/Text/Text';
import { Checkbox, Form } from 'antd';

interface IProps {
	onToggle: () => void;
	isFranchiseFeeSupported: boolean;
}

const FranchiseFeeCheckbox: React.FC<IProps> = ({ onToggle, isFranchiseFeeSupported }) => {
	return (
		<Form.Item>
			<Checkbox checked={isFranchiseFeeSupported} onChange={onToggle} data-test="FranchiseFeeCheckbox">
				<Text translationNameSpace="form" translationKey="franchiseFeeSupportedLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(FranchiseFeeCheckbox);
